module.exports = __webpack_public_path__ + "static/img/yzs.ca4bc81d.png";